import React from "react";
import { Fab, Tooltip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function WhatsAppFloatButton() {
    const phone = "5599999999999"; // <-- TROQUE
    const text = encodeURIComponent("Olá! Quero orçamento para um projeto.");
    const link = `https://wa.me/${phone}?text=${text}`;

    return (
        <Tooltip title="Falar no WhatsApp" placement="left">
            <Fab
                component="a"
                href={link}
                target="_blank"
                rel="noreferrer"
                sx={{
                    position: "fixed",
                    right: 18,
                    bottom: 18,
                    zIndex: 9999,
                    bgcolor: "var(--verdeClaro)",
                    color: "#000",
                    fontWeight: 900,
                    boxShadow: "0 18px 48px rgba(172,201,14,0.28)",
                    "&:hover": { bgcolor: "var(--verdeClaro)" },
                }}
            >
                <WhatsAppIcon />
            </Fab>
        </Tooltip>
    );
}